ACC.editlistpopup = {


  editlist: function() {
    $(document).on('click', '.ph-editshoppinglistpopup', function() {
      ACC.editlistpopup.editlistclick($(this).closest('.ph-panel-group').attr('id'));
    });

    $(document).on('click', '.ph-deleteshoppinglistpopup', function() {
      var dataVal = $(this).attr('data-id');

      ACC.editlistpopup.deletelistclick(dataVal);
    });
  },

  editlistclick: function(item) {
    $.colorbox({
      html: $('.ph-editlistpopup[data-id=' + item + ']').html(),
      maxWidth: '522px',
      width: '100%',
      height: '100%',
      maxHeight: '600px',
      scrolling: true,
      close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
      onComplete: function() {
        if ($(window).width() < 768) {
          $('#colorbox').addClass('ph-favmobile-topposition');
          $('#colorbox').css('position', 'fixed');
          $('html').addClass('ph-modal-open');
        }

        if ($(window).width() === 768) {
          var topPos = $('.ph-editlistpopup').offset().top + 50;

          $('#colorbox').css('top', topPos);
        }

        var outerPopupHeight = $('#cboxContent').outerHeight() - 15,
            centerDivPopupHeight = $('#cboxContent .ph-shoplisttitle').outerHeight(),
            shopFooterHeight = $('#cboxContent .ph-shopfootersection').outerHeight(),
            finalShopDivHeight = outerPopupHeight - (centerDivPopupHeight + shopFooterHeight);

        $('.ph-editlistpopupmain').css({
          minHeight: 200,
          height: finalShopDivHeight
        });

        $(document).on('click', '.ph-deletefavshoppinglist', function() {
          $('#favRemoveCode').val($(this).attr('data-productid'));
          $('#removeFavForm').submit();
        });
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('html').removeClass('ph-modal-open');
      }
    });
  },

  deletelistclick: function(dataval) {
    $.colorbox({
      html: $('.ph-deletelistpopup[data-id=' + dataval + ']').html(),
      maxWidth: '522px',
      width: '100%',
      height: 'auto',
      close: '<button type=\'button\' id=\'ph-cboxClose\' class=\'ph-favclose\'><span class=\'ph-icon-cross ph-favcross\'></span></button>',
      onComplete: function() {
        if ($(window).width() < 768) {
          $('#colorbox').css('top', 150);
          $('html').removeClass('ph-modal-open');
        }

        if ($(window).width() === 768) {
          var topPos = $('.ph-deletelistpopup').offset().top;

          $('#colorbox').css('top', topPos + 100);
        }

        $(document).on('click', '.ph-deletefavshoppinglist', function() {
          $('#favRemoveCode').val($(this).attr('data-productid'));
          $('#removeFavForm').submit();
        });
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  checkQty: function(item) {
    var total = 0;

    item.each(function() {
      total = total + parseInt($(this).val(), 10);
    });

    return total;
  },
  spAcknowledgementCheck: function(submitElement) {
    var showAcknowledgePopup = 'false';

    if (ACC.product.checkForSpInCart()) {
      submitElement.parents('.ph-addListToCartForm').find('.ph-favproditem').each(function() {
        if ($(this).find('.isSpProduct').text() === 'true' && $(this).find('.ph-favqty').val() > 0) {
          showAcknowledgePopup = 'true';
        }
      });
    }

    return showAcknowledgePopup;
  }
};


$(document).ready(function() {
  ACC.editlistpopup.editlist();

  var addfavcartClass = '.ph-addfavcart';

  $(document).on('click', '.ph-updatebutton', function() {
    var newListName = $('#cboxContent .newlistname').val();
    var oldListName = $(this).attr('data-old');

    if (newListName !== '') {
      $.ajax({
        url: ACC.config.contextPath + '/shoppingList/updateListName',
        data: {
          oldListName: oldListName,
          newListName: newListName
        },
        type: 'POST',
        datatype: 'json'
      });

      setTimeout(function() {
        location.reload();
      }, 1000);
    }
  });

  $(document).on('click', '.ph-favlistdelete', function() {
    var $row = $($(this).attr('data-clearDivId')),
        shopListName = $('#colorbox').find('.ph-favshoplistinput').val(),
        productCode = $(this).attr('data-productCode'),
        uniqueCode = $(this).attr('data-uniqueCode');

    $.ajax({
      url: ACC.config.contextPath + '/shoppingList/removeProduct',
      data: {
        listName: shopListName,
        productCode: productCode,
        uniqueCode: uniqueCode
      },
      type: 'POST',
      datatype: 'json'
    });
    $row.remove();

    var dataId = $(this).attr('data-clearDivId'),
        dataAccordionId = $(this).attr('data-accordion-num');

    $('.' + dataAccordionId).find(dataId).remove();
    $('.ph-editlistpopupmain').find(dataId).remove();

    var listName = shopListName.replace(/\s/g, ''),
        productCount = parseInt($('#listProductCount' + listName).val(), 10);

    productCount = productCount - 1;

    if (productCount === 0) {
      $('.ph-addshoppinglisttocart').attr('disabled', 'disabled').css('background', '#909291');
    } else {
      $('.ph-addshoppinglisttocart').removeAttr('disabled').css('background', '#e26d00');
    }

    $('#listProductCount' + listName).val(productCount);
  });

  $(addfavcartClass).click(function() {
    var favListName = $(this).attr('data-listName'),
        addListFormCount = $(this).attr('data-count'),
        favqtyCount = 0,
        addListToCartFormId = 'addListToCartForm_';

    $('#' + addListToCartFormId + addListFormCount).find('.ph-favqty').each(function() {
      favqtyCount = favqtyCount + parseInt($(this).val(), 10);
    });

    if (favqtyCount > 0 && ACC.editlistpopup.spAcknowledgementCheck($(this)) === 'true') {
      $('#addListToCartName_' + addListFormCount).val(favListName);
      ACC.quickOrder.changeAcknowledgePopup($('#' + addListToCartFormId + addListFormCount));
    } else if (favqtyCount > 0) {
      $('#' + addListToCartFormId + addListFormCount).find(addfavcartClass).addClass('ph-disabledbutton');
      $('#addListToCartName_' + addListFormCount).val(favListName);
      $('#' + addListToCartFormId + addListFormCount).submit();
    }
  });

  $('input.ph-favqty[type="number"]').on('blur', function() {
    var favRowCount = $(this).attr('favlistqty'),
        itemparent = $(this).closest('.ph-panel-body').find('input.ph-favqty[type="number"]'),
        favqty = ACC.editlistpopup.checkQty(itemparent);

    if (favqty > 0) {
      $('#accordion_' + favRowCount).find(addfavcartClass).removeAttr('disabled').removeClass('ph-mylist__addtocart--disabled').addClass('ph-mylist__addtocart--enabled');
    } else {
      $('#accordion_' + favRowCount).find(addfavcartClass).attr('disabled', 'disabled').removeClass('ph-mylist__addtocart--enabled').addClass('ph-mylist__addtocart--disabled');
    }
  });

  $(document).on('click', '.ph-icon-close.ph-info-closebtn', function() {
    $(this).parent('.ph-information_message').addClass('hiddenClass');
  });
});


$(document).on('click', '.ph-savedlist__tooltipicon', function() {
  $('.ph-shoppingListTooltip').toggleClass('hidden');
});
